// extracted by mini-css-extract-plugin
export var arrow = "InternalLinking-module--arrow--1130b";
export var background = "InternalLinking-module--background--b964a";
export var container = "InternalLinking-module--container--4244e";
export var icon = "InternalLinking-module--icon--ebfaf";
export var link = "InternalLinking-module--link--24ffe";
export var readMore = "InternalLinking-module--read-more--2adda";
export var sublist = "InternalLinking-module--sublist--23678";
export var typographies = "InternalLinking-module--typographies--e8a5f";
export var wrapper = "InternalLinking-module--wrapper--a2923";